"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.grainSubset = exports.resolveGrain = void 0;
const torch_data_defs_1 = require("torch-data-defs");
const signature_1 = require("../signature");
function resolveGrain(datasetDef, datasetRepo) {
    return datasetDef.grain.map(grainStr => {
        let resolved = torch_data_defs_1.default.resolveField(grainStr, datasetDef.name, datasetRepo.datasetByName);
        return new signature_1.GrainSignature(resolved[0], resolved[1]);
    });
}
exports.resolveGrain = resolveGrain;
function grainSubset(grain1, grain2) {
    let common = [];
    for (let g1 of grain1) {
        let exists = !!grain2.find(g2 => g1.equals(g2));
        if (exists)
            common.push(g1);
    }
    return common;
}
exports.grainSubset = grainSubset;
